module.exports = __webpack_public_path__ + "static/media/Viper.72abe66e.png";